import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Lock, CreditCard, Zap, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function OfferSection() {
  const [selected, setSelected] = useState<'pro' | 'elite'>('elite');
  const links = {
    pro: 'https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNCXPkTADN4MoGuKX8kUaws/es-ar?_r=AQAB3s5Yxbr3VOmXQ5Sh-ybs7N6l5MM3sd3IOjuTEg336l4&cart_link_id=eJ51m7on&preview_theme_id=151828791463',
    elite: 'https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNCXPIbyh0u8LOKFcNvUoAE/es-ar?_r=AQABFK_IC4_nF6-3bT1JGBFsexg7SPqj99sSsu-j7Q1HI5c&cart_link_id=PTUojaCP&preview_theme_id=151828791463'
  };
  return <section id="comprar" className="px-3 py-12 bg-cream" data-id="element-114">
      <div className="max-w-[680px] mx-auto" data-id="element-115">
        <FadeIn className="text-center mb-8" data-id="element-116">
          <h2 className="text-2xl md:text-3xl font-bold text-ink mb-2" data-id="element-117">
            Elegí tu{' '}
            <span className="text-accent" data-id="element-118">MegaPack Inclusión Lista™</span>
          </h2>
        </FadeIn>

        <div className="space-y-4 mb-8" data-id="element-119">
          {/* Card 1: Base */}
          <FadeIn delay={0.1} data-id="element-120">
            <div onClick={() => setSelected('pro')} className={`relative bg-surface/30 rounded-xl p-5 md:p-6 flex items-center gap-4 md:gap-5 cursor-pointer transition-all group ${selected === 'pro' ? 'border-2 border-accent shadow-[0_0_30px_rgba(184,153,104,0.20)]' : 'border border-accent/20 hover:border-accent/40'}`} data-id="element-121">
              <div className={`shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'pro' ? 'border-accent' : 'border-muted/40 group-hover:border-accent/50'}`} data-id="element-122">
                <div className={`w-3 h-3 rounded-full ${selected === 'pro' ? 'bg-accent' : 'bg-transparent'}`} data-id="element-123" />
              </div>

              <div className="flex-1 min-w-0" data-id="element-124">
                <h3 className={`text-base md:text-lg font-bold mb-1 ${selected === 'pro' ? 'text-accent' : 'text-ink'}`} data-id="element-125">
                  MegaPack Inclusión Lista™
                </h3>
                <p className="text-xs text-muted" data-id="element-126">6 tomos + 6 bonos</p>
              </div>

              <div className="text-right shrink-0" data-id="element-127">
                <p className="text-muted/70 line-through text-sm mb-0.5" data-id="element-128">
                  $34.990
                </p>
                <p className={`text-2xl md:text-3xl font-bold ${selected === 'pro' ? 'text-accent' : 'text-ink'}`} data-id="element-129">
                  $19.990
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Card 2: Premium (Highlighted) */}
          <FadeIn delay={0.2} data-id="element-130">
            <div onClick={() => setSelected('elite')} className={`relative bg-surface/30 rounded-xl p-5 md:p-6 flex items-center gap-4 md:gap-5 cursor-pointer transition-all ${selected === 'elite' ? 'border-2 border-accent shadow-[0_0_30px_rgba(184,153,104,0.20)]' : 'border border-accent/20 hover:border-accent/40'}`} data-id="element-131">
              <div className="absolute -top-3 left-6 flex items-center gap-2" data-id="element-132">
                <span className="bg-accent text-black text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-133">
                  MÁS ELEGIDO
                </span>
                <span className="text-ink text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider bg-accent/80" data-id="element-134">
                  AHORRÁS $16.000
                </span>
              </div>

              <div className={`shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'elite' ? 'border-accent' : 'border-muted/40'}`} data-id="element-135">
                <div className={`w-3 h-3 rounded-full ${selected === 'elite' ? 'bg-accent' : 'bg-transparent'}`} data-id="element-136" />
              </div>

              <div className="flex-1 min-w-0 pt-2" data-id="element-137">
                <h3 className={`text-base md:text-lg font-bold mb-1 leading-tight ${selected === 'elite' ? 'text-accent' : 'text-ink'}`} data-id="element-138">
                  MegaPack Inclusión Lista™ + Pack Cuadernillos Visuales
                </h3>
                <p className="text-xs text-muted" data-id="element-139">
                  6 tomos + 6 bonos + 5 cuadernillos extra
                </p>
              </div>

              <div className="text-right shrink-0 pt-2" data-id="element-140">
                <p className="text-muted/70 line-through text-sm mb-0.5" data-id="element-141">
                  $43.990
                </p>
                <p className={`text-2xl md:text-3xl font-bold ${selected === 'elite' ? 'text-accent' : 'text-ink'}`} data-id="element-142">
                  $27.990
                </p>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Main CTA */}
        <FadeIn delay={0.3} className="text-center mb-8" data-id="element-143">
          <motion.a href={links[selected]} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full bg-accent hover:bg-accent/90 text-black font-bold md:text-lg py-4 px-8 rounded-xl shadow-lg shadow-accent/20 transition-all text-center" data-id="element-144">
            SI, QUIERO EL MATERIAL✨
          </motion.a>
          <p className="text-muted text-sm mt-4 italic" data-id="element-145">
            La opción más elegida por quienes quieren la biblioteca completa.
          </p>
        </FadeIn>

        {/* Trust Bar */}
        <FadeIn delay={0.4} className="mb-10" data-id="element-146">
          <div className="flex flex-wrap justify-center gap-4 md:gap-6 bg-surface/70 border border-accent/20 rounded-lg py-4 px-4" data-id="element-147">
            <div className="flex items-center gap-2 text-muted text-sm font-medium" data-id="element-148">
              <Lock size={16} className="text-accent" data-id="element-149" />
              Pago seguro
            </div>
            <div className="flex items-center gap-2 text-muted text-sm font-medium" data-id="element-150">
              <Zap size={16} className="text-accent" data-id="element-151" />
              Acceso inmediato
            </div>
            <div className="flex items-center gap-2 text-muted text-sm font-medium" data-id="element-152">
              <ShieldCheck size={16} className="text-accent" data-id="element-153" />
              Garantía 7 días
            </div>
            <div className="flex items-center gap-2 text-muted text-sm font-medium" data-id="element-154">
              <CreditCard size={16} className="text-accent" data-id="element-155" />
              Mercado Pago
            </div>
          </div>
        </FadeIn>

        {/* Módulos */}
        <FadeIn delay={0.55} data-id="element-156">
          <div className="bg-surface/60 border border-accent/20 rounded-xl p-5 md:p-6 mb-8" data-id="element-157">
            <h3 className="text-base md:text-lg font-bold text-accent mb-4 text-center" data-id="element-158">
              Pack Cuadernillos Visuales — 5 cuadernillos extra incluidos
            </h3>
            <ul className="space-y-3" data-id="element-159">
              <li className="flex items-start gap-3 text-ink/80 text-sm" data-id="element-160">
                <ChevronRight size={16} className="text-accent shrink-0 mt-0.5" data-id="element-161" />
                <span data-id="element-162">
                  <strong className="text-ink" data-id="element-163">Cuadernillo 1</strong> —
                  Secuencias Visuales, Orden y Comprensión
                </span>
              </li>
              <li className="flex items-start gap-3 text-ink/80 text-sm" data-id="element-164">
                <ChevronRight size={16} className="text-accent shrink-0 mt-0.5" data-id="element-165" />
                <span data-id="element-166">
                  <strong className="text-ink" data-id="element-167">Cuadernillo 2</strong> —
                  Asociación, Clasificación y Relación Visual
                </span>
              </li>
              <li className="flex items-start gap-3 text-ink/80 text-sm" data-id="element-168">
                <ChevronRight size={16} className="text-accent shrink-0 mt-0.5" data-id="element-169" />
                <span data-id="element-170">
                  <strong className="text-ink" data-id="element-171">Cuadernillo 3</strong> —
                  Tarjetas, Tableros y Actividades Recortables
                </span>
              </li>
              <li className="flex items-start gap-3 text-ink/80 text-sm" data-id="element-172">
                <ChevronRight size={16} className="text-accent shrink-0 mt-0.5" data-id="element-173" />
                <span data-id="element-174">
                  <strong className="text-ink" data-id="element-175">Cuadernillo 4</strong> —
                  Comprensión Visual, Lenguaje y Respuesta Funcional
                </span>
              </li>
              <li className="flex items-start gap-3 text-ink/80 text-sm" data-id="element-176">
                <ChevronRight size={16} className="text-accent shrink-0 mt-0.5" data-id="element-177" />
                <span data-id="element-178">
                  <strong className="text-ink" data-id="element-179">Cuadernillo 5</strong> — Láminas
                  Visuales para Colorear
                </span>
              </li>
            </ul>
            <p className="text-center text-xs text-muted/70 mt-5 pt-4 border-t border-ink/10" data-id="element-180">
              * Este pack solo se incluye en la oferta premium.
            </p>
          </div>
        </FadeIn>

        {/* Objections */}
        <FadeIn delay={0.6} data-id="element-181">
          <div className="grid md:grid-cols-3 gap-4" data-id="element-182">
            <div className="bg-surface/30 border border-accent/15 p-5 rounded-xl" data-id="element-183">
              <h4 className="font-bold text-accent mb-2 text-sm" data-id="element-184">
                ¿Y si recién empiezo en intervención?
              </h4>
              <p className="text-muted text-xs leading-relaxed" data-id="element-185">
                Vas a tener una biblioteca organizada por edades para sostener
                tus primeras sesiones con criterio y estructura.
              </p>
            </div>
            <div className="bg-surface/30 border border-accent/15 p-5 rounded-xl" data-id="element-186">
              <h4 className="font-bold text-accent mb-2 text-sm" data-id="element-187">
                ¿Y si ya tengo experiencia?
              </h4>
              <p className="text-muted text-xs leading-relaxed" data-id="element-188">
                Te ahorra horas de armado de materiales y te da un sistema
                visual listo para aplicar con distintas edades.
              </p>
            </div>
            <div className="bg-surface/30 border border-accent/15 p-5 rounded-xl" data-id="element-189">
              <h4 className="font-bold text-accent mb-2 text-sm" data-id="element-190">
                ¿Y si no me sirve?
              </h4>
              <p className="text-muted text-xs leading-relaxed" data-id="element-191">
                Contás con 7 días de garantía. Si no era lo que esperabas, se
                devuelve el 100%.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}